module.exports = __webpack_public_path__ + "static/media/border_bottom.745967e3.svg";